// extracted by mini-css-extract-plugin
export default {"paperless-terms-modal":"PaperlessTermsModal_paperless-terms-modal__yJELY","title":"PaperlessTermsModal_title__wLVu8"};